import { useState } from "react";

export default function useNavbar() {
  const [drawerVisible, setDrawerVisible] = useState(false);

  const showDrawer = () => {
    setDrawerVisible(true);
  };

  const closeDrawer = () => {
    setDrawerVisible(false);
  };

  return {
    drawerVisible,
    showDrawer,
    closeDrawer,
  };
}
